import { AvvirEvent } from "type_aliases";

export type ViewerRenderCompletedPayload = {
  durationMs: number;
  projectId: string;
  floorId: string;
  scanDatasetId: string;
};

export type ViewerRenderCompletedEvent = AvvirEvent<typeof VIEWER_RENDER_COMPLETED, ViewerRenderCompletedPayload>;

const viewerRenderCompleted = (payload: ViewerRenderCompletedPayload): ViewerRenderCompletedEvent => ({
  type: VIEWER_RENDER_COMPLETED,
  payload,
});

export const VIEWER_RENDER_COMPLETED = "viewer_render_completed";

export default viewerRenderCompleted;